<template>
  <FormContainer>
    <template #content>
      <div class="form__bloc">
        <WrapperToggleSwitch
          id="field_206"
          v-model="attestationResteChargeContributionModel"
          label="En cas de reste à charge sur votre dossier, souhaitez-vous qu’il soit pris en charge ? "
          :required="meta.financement?.attestationResteChargeContribution?.$status === PropertyStatus.Required"
          :alertLabel="meta.financement?.attestationResteChargeContribution?.$messageErreurDirty!"
          :disabled="meta.financement?.attestationResteChargeContribution?.$status === PropertyStatus.NotPresent"
          :items="OuiOuNon"
          :readonly
          nbMaxLines="2"
          class="col-12 col-md-14 col-sm-36"
        />
      </div>
      <div class="form__bloc">
        <WrapperDropdown
          id="field_207"
          v-if="meta.financement?.modePriseEnChargeReste?.$status !== PropertyStatus.NotPresent"
          v-model="modePriseEnChargeResteModel"
          label="Le reste à charge doit être pris sur votre contribution :"
          :required="meta.financement?.modePriseEnChargeReste?.$status === PropertyStatus.Required"
          :alertLabel="meta.financement?.modePriseEnChargeReste?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          :items="resteChargeContribution"
          :readonly
          force-value
        />
        <WrapperDropdown
          v-else
          id="field_207"
          label="Le reste à charge doit être pris sur votre contribution :"
          class="col-12 col-md-18 col-sm-36"
          disabled
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import {
    ResteChargeContributionTypePublicInterimaireCDI,
    ResteChargeContributionTypePublicPermanent,
  } from '@/features/domaine/types/opco/Demande/PROA/ResteChargeContribution'
  import { ResteChargeContributionLibelle } from '@/features/domaine/types/opco/Demande/shared/ResteChargeContribution'
  import { arrayToDropdownItems, OuiOuNon } from '@/features/interface/shared/tools'
  import type { DropdownItem } from '@designSystem/index'
  import { storeToRefs } from 'pinia'
  import { computed } from 'vue'
  import FormContainer from '../../../shared/components/FormContainer.vue'
  import { useDemandePROAStore } from '../../useDemandePROAStore'

  const store = useDemandePROAStore()
  const { setupFieldWithKey } = store
  const { readonly, meta, model } = storeToRefs(store)

  const attestationResteChargeContributionModel = setupFieldWithKey<boolean>('financement.attestationResteChargeContribution')
  const modePriseEnChargeResteModel = setupFieldWithKey<string>('financement.modePriseEnChargeReste')

  const resteChargeContribution = computed<DropdownItem<string>[]>(() => {
    if (model.value?.typePublic === 'Interimaire' && model.value?.salarie?.situation === 'Cdii') {
      return arrayToDropdownItems(ResteChargeContributionTypePublicInterimaireCDI, ResteChargeContributionLibelle)
    }
    return arrayToDropdownItems(ResteChargeContributionTypePublicPermanent, ResteChargeContributionLibelle)
  })
</script>
